// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8w-4";
export var collapsed = "_8w-1";
export var headerBar = "_8w-0";
export var leftHeaderContent = "_8w-3";
export var subjectContainer = "_8w-2";